export default "__VITE_ASSET__BsF$paRJ__"